import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout, PersonalPath } from 'entities/ExportRouters'

export const AccessTokensAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.access_tokens}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          method: 'replace',
          path: `/${PersonalPath.profile}`,
        })
      }}
    />
  )
})
